import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: () => import('@/views/Home.vue'),
		props: true,
		meta: {
			title: 'Forside',
			metaTags: [
				{
					name: 'description',
					content: "absi er Danmarks største udbyder af samhandelsløsninger til virksomheder. Kontakt os i dag for en snak om hvad absi kan gøre for jeres virksomhed."
				},
				{
					property: 'og:description',
					content: "absi er Danmarks største udbyder af samhandelsløsninger til virksomheder. Kontakt os i dag for en snak om hvad absi kan gøre for jeres virksomhed."
				}
			]
		},
	},
	{
		path: "/fordele",
		name: "Advantages",
		component: () => import('@/views/Advantages.vue'),
		meta: {
			title: 'Fordele',
			metaTags: [
				{
					name: 'description',
					content: "Med det unikke absi koncept, kan tilmeldte virksomheder på en nem og sikker måde handle med hinanden og få mærkbare fordele."
				},
				{
					property: 'og:description',
					content: "Med det unikke absi koncept, kan tilmeldte virksomheder på en nem og sikker måde handle med hinanden og få mærkbare fordele."
				}
			]
		},
	},
	{
		path: "/om-absi",
		name: "About",
		component: () => import('@/views/About.vue'),
		meta: {
			title: 'Om absi',
			metaTags: [
				{
					name: 'description',
					content: "absi har eksisteret i Danmark siden 2003, og var den tredje virksomhed i verden til at introducere et betalingskort til multilateral modkøbshandel."
				},
				{
					property: 'og:description',
					content: "absi har eksisteret i Danmark siden 2003, og var den tredje virksomhed i verden til at introducere et betalingskort til multilateral modkøbshandel."
				}
			]
		},
	},
	{
		path: "/kontakt",
		name: "Contact",
		component: () => import('@/views/Contact.vue'),
		meta: {
			title: 'Kontakt',
			metaTags: [
				{
					name: 'description',
					content: "absi er aktiv i Danmark, Sverige og Letland. Kontakt os i dag."
				},
				{
					property: 'og:description',
					content: "absi er aktiv i Danmark, Sverige og Letland. Kontakt os i dag."
				}
			]
		},
	},
	{
		path: '/404',
		name: 'NotFound',
		component: () => import('@/views/PageNotFound.vue'),
		meta: {
			title: 'Siden blev ikke fundet',
			metaTags: [
				{
					name: 'description',
					content: "siden findes desværre ikke"
				},
				{
					property: 'og:description',
					content: "siden findes desværre ikke"
				},
				{
					name: 'robots',
					content: 'noindex'
				}
			]
		},
	},
	{
		path: '*',
		redirect: '/404',
	},
];

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior() {
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	},
});

// found on: https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
		// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title + ' - absi';
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title + ' - absi';
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	console.log(nearestWithMeta.meta.metaTags[0]);

	const metaDesc = nearestWithMeta.meta.metaTags;
	if (document.querySelector('meta[name="description"]') && document.querySelector('meta[property="og:description"]')) {
		document.querySelector('meta[name="description"]').setAttribute("content", metaDesc[0].content);
		document.querySelector('meta[property="og:description"]').setAttribute("content", metaDesc[1].content);
	}

	if (metaDesc[2] && !document.querySelector("meta[name='robots']")) {
		const tag = document.createElement('meta');
		tag.name = 'robots';
		tag.setAttribute('content', metaDesc[2].content)
		document.head.appendChild(tag);
	} else if (document.querySelector("meta[name='robots']")){
		document.querySelector("meta[name='robots']").remove();
	}

	if (to.name === 'Home' && to.query.errormsg) {
		next({ name: 'Home', params: { errormsg: to.query.errormsg } });
	} else {
		next();
	}
});

export default router;